import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import GifFeed from "../../components/feeds/GifFeed";
import "./style.css";

export default function GifPage() {
  const { user } = useSelector((state) => ({ ...state }));
  const navigate = useNavigate();

  if (!user) {
    navigate("/login");
    return null;
  }

  return (
    <div className="feed_page gif_page">
      <header className="feed_header">
        <button className="feed_back_btn" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>
        <div className="feed_logo gif_logo">
          <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
            <path d="M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z" />
          </svg>
          <span>GIFs</span>
        </div>

        <div className="feed_nav_icons">
          <Link to="/" className="feed_nav_btn" title="Home">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
          </Link>
          <Link to="/feeds" className="feed_nav_btn" title="Feeds">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-2.03-2.71-1.41 1.41L10.5 19l4.96-6.29z" />
            </svg>
          </Link>
          <Link to="/chat" className="feed_nav_btn" title="Chat">
            <svg viewBox="0 0 28 28" fill="currentColor" width="20" height="20">
              <path d="M14 2.042c6.76 0 12 4.952 12 11.64S20.76 25.322 14 25.322a13.091 13.091 0 0 1-3.474-.461.956 .956 0 0 0-.641.047L7.5 25.959a.961.961 0 0 1-1.348-.849l-.065-2.134a.957.957 0 0 0-.322-.684A11.389 11.389 0 0 1 2 13.682C2 6.994 7.24 2.042 14 2.042ZM6.794 17.086a.57.57 0 0 0 .827.758l3.786-2.874a.722.722 0 0 1 .868 0l2.8 2.1a1.8 1.8 0 0 0 2.6-.481l3.525-5.592a.57.57 0 0 0-.827-.758l-3.786 2.874a.722.722 0 0 1-.868 0l-2.8-2.1a1.8 1.8 0 0 0-2.6.481Z" />
            </svg>
          </Link>
          <div className="feed_nav_btn" onClick={() => navigate("/notifications")} style={{ position: "relative", cursor: "pointer" }} title="Notificações">
            <svg viewBox="0 0 28 28" fill="currentColor" width="20" height="20">
              <path d="M7.847 23.488C9.207 23.488 11.443 23.363 14.467 22.806 13.944 24.228 12.581 25.247 10.98 25.247 9.649 25.247 8.483 24.542 7.825 23.488L7.847 23.488ZM24.923 15.73C25.17 17.002 24.278 18.127 22.27 19.076 21.17 19.595 18.724 20.583 14.684 21.369 11.568 21.974 9.285 22.113 7.848 22.113 7.421 22.113 7.068 22.101 6.79 22.085 4.574 21.958 3.324 21.248 3.077 19.976 2.702 18.049 3.295 17.305 4.278 16.073L4.537 15.748C5.2 14.907 5.459 14.081 5.035 11.902 4.086 7.022 6.284 3.687 11.064 2.753 15.846 1.83 19.134 4.096 20.083 8.977 20.506 11.156 21.056 11.824 21.986 12.355L21.986 12.356 22.348 12.561C23.72 13.335 24.548 13.802 24.923 15.73Z" />
            </svg>
            <span className="feed_nav_notification_badge">5</span>
          </div>
          <Link to={`/profile/${user.username}`} className="feed_nav_btn" title="Meu Perfil">
            <img src={user.picture} alt={user.first_name} />
          </Link>
        </div>
        <button className="feed_create_btn" onClick={() => navigate(".", { state: { createPost: "gif" } })}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
        </button>
      </header>
      <GifFeed />
    </div>
  );
}
